import {logger} from '@/utils/logger';

/**
 * Rejection handler for a promise an admin screen deliberately does not
 * await.
 *
 * Nearly every fire-and-forget call it is attached to goes through a function
 * that already handles its own failures, into `error` state or a toast, so the
 * handler this builds normally never runs. It exists so that a throw from that
 * `catch` or `finally` is logged instead of escaping as an unhandled
 * rejection, which is what `@typescript-eslint/no-floating-promises` is there
 * to prevent. The `void` operator would satisfy the rule while re-creating
 * exactly that problem, so it is not used for these calls.
 *
 * Attaching it never changes behaviour: the call was fire-and-forget before
 * and stays fire-and-forget, it just has somewhere for a rejection to go.
 *
 * @param message what failed, without trailing punctuation. Logged as
 *   `"<message>: <error>"`, matching the existing `logger.error` call sites.
 */
export const logRejection =
  (message: string) =>
  (err: unknown): void => {
    logger.error(`${message}:`, err);
  };
